import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./Signup.css"; 
import { signup ,googleSignin} from "../../services/apiService";
import {  showToast } from '../Toast/CommonToast';
import LoaderWithBackdrop from "../Loader/loader";
import CheckIcon from '@mui/icons-material/Check';
import ReusableButton from "../Reusable/PrimaryButton/PrimaryButton";

const Signup: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");
  const [formErrors, setFormErrors] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const navigate = useNavigate();
  // const desktop = window.innerWidth > 1440 


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    // Live password validation and error clearing
    if (name === "password") {
      // Password strength logic
      if (
        value.length >= 8 &&
        /[0-9]/.test(value) &&
        /[a-z]/.test(value) &&
        /[!@#$%^&*]/.test(value)
      ) {
        setPasswordStrength("strong");
      } else if (value.length >= 8 && /[0-9]/.test(value)) {
        setPasswordStrength("medium");
      } else if (value.length >= 8) {
        setPasswordStrength("weak");
      } else {
        setPasswordStrength("");
      }

      // Password error live update
      setFormErrors((prev) => ({
        ...prev,
        password:
          !value
            ? "Password is required"
            : passwordStrength === "weak"
            ? "Password must be at least 8 characters, include a number, a symbol, a lowercase and uppercase letter."
            : ""
      }));
    }
  };
  //onBlur functions
  const handleBlur = () => {
    // Require at least 1 lowercase, 1 uppercase, 1 number, 1 symbol, min 8 chars
    const regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;
    const errors = { ...formErrors };

    if (!formData.password) {
      errors.password = "Password is required";
    } else if (!regularExpression.test(formData.password) && passwordStrength === "weak") {
      errors.password =
        "Password must be at least 8 characters, include a number, a symbol, a lowercase and uppercase letter.";
    } else {
      errors.password = "";
    }

    setFormErrors(errors);
  };

  const validateForm = () => {
    const errors = { ...formErrors };
    let isValid = true;

    // Validate full name
    if (!formData.name) {
      errors.name = "Full name is required";
      isValid = false;
    } else {
      errors.name = "";
    }

    // Validate email
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!formData.email) {
      errors.email = "Email is required";
      isValid = false;
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Invalid email format";
      isValid = false;
    } else {
      errors.email = "";
    }

    // Validate password
    // Require at least 1 lowercase, 1 uppercase, 1 number, 1 symbol, min 8 chars
    const regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;
    if (!formData.password) {
      errors.password = "Password is required";
      isValid = false;
    } else if (!regularExpression.test(formData.password)) {
      errors.password =
        "Password must be at least 8 characters, include a number, a symbol, a lowercase and uppercase letter.";
      isValid = false;
    } else {
      errors.password = "";
    }
    // Validate confirmPassword
    if (!formData.confirmPassword) {
      errors.confirmPassword = "Please confirm your password";
      isValid = false;
    } else if (formData.confirmPassword !== formData.password) {
      errors.confirmPassword = "Passwords do not match";
      isValid = false;
    } else {
      errors.confirmPassword = "";
    }


    setFormErrors(errors);
    return isValid;
  };

  const handleSubmit = async (event: any) => {
    // console.log('Form submitted', formData);

    event.preventDefault();
    try {
      if (validateForm()) {
        
        // console.log("Form submitted successfully", formData);
        const signUp = {
          name: formData.name,
          email: formData.email,
          password: formData.password,
        }
        // console.log(signUp);
        setLoading(true);
        const singUpResponse = await signup(signUp);
        // console.log(singUpResponse.data);
        setLoading(false);
        if (singUpResponse.data.status === 'true') {
          localStorage.setItem("accessToken", singUpResponse.data?.data?.token);
          localStorage.setItem("refreshToken", singUpResponse.data?.data?.refreshToken);
          localStorage.setItem("name", singUpResponse.data?.data?.name);
          localStorage.setItem("userId", singUpResponse.data?.data?._id);
          localStorage.setItem('email', singUpResponse.data?.data?.email);
          localStorage.setItem('isVerified', singUpResponse.data?.data?.isVerified);
          localStorage.setItem('email', singUpResponse.data?.data?.email);
          localStorage.setItem('isGoogleLogin', singUpResponse.data?.data?.isGoogleLogin);
          setLoading(false)
          if(singUpResponse?.data?.data?.isGoogleLogin === true){
            showToast("You have been registered successfully", "success");
            navigate('/home');
          }else{
            
            navigate("/verification");
          }
        }else{
          showToast(singUpResponse.data.message, "error");
        }
        // const toastContent = (
        //   <DynamicToastContent
        //     icon={messageLogo}
        //     message={
        //       "You have been registered. An email has been sent to abhishek@agiliztech.com for verification."
        //     }
        //   />
        // );
        // toast(toastContent, {
        //   closeOnClick: false,
        //   pauseOnHover: false,
        //   draggable: false,
        //   onClose: ()=>{
        //     navigate('/login')
        //   }
        // });

      }
    } catch (error: any) {
      const errorData = error?.response?.data || error?.data;
                const errorIsVerified = errorData?.data?.isVerified ?? errorData?.isVerified;
                const errorMessage = errorData?.message || error?.message;
              if(errorIsVerified === false || errorIsVerified === 'false'){
                navigate('/verification');
                                }
      // console.log(error.message);
      // console.log('Error in submitting form', error);
      setLoading(false);
      showToast(error.message, "error");
    }

  };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = () => {
    navigate("/login");
  }
   const handleGoogleLogin = async () => {
          try {
              const response = await googleSignin();
              if (response && response.data?.url) {
                  window.location.href = response.data.url;
              } else {
                  showToast("Google login URL not found", "error");
              }
          } catch (error) {
              showToast("An error occurred during Google login", "error");
          }
      };

  return (
    <>
      <LoaderWithBackdrop open={loading} />
      <Box className="maincontainer">

        <Box className="imagecontainer">
        </Box>

        <Box className="leftcontainer">

          <Box sx={{ maxWidth: 350, width: "100%" }}>
            <Box sx={{ textAlign: "left", marginBottom: 3 }}>
              <img
                            src={'/assets/showcasaNew.svg'}
                            alt="Logo"
                            className="showcasalogo"
                            // style={{ width: 55, height: 55, marginBottom: 15 }}
                        />
              {/* <Typography className="Title"
                variant="h4"
                sx={{
                  fontWeight: 400,
                  fontSize: 40,
                  fontFamily: "ADLaM Display",
                  marginBottom: 1,
                }}
              > */}
                {/* Showcasaai
              </Typography> */}
              
            </Box>
            <Typography
                variant="subtitle1"
                className='registerTitle'
              >
                Sign up 
              </Typography>

            <div className="form">
              <TextField
                label="Full Name"
                variant="outlined"
                name="name"
                value={formData.name}
                onChange={handleChange}
                error={Boolean(formErrors.name)}
                helperText={formErrors.name}
                className="textField"
                fullWidth
                margin="normal"
              />

              <TextField
                label="Email Address"
                variant="outlined"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                error={Boolean(formErrors.email)}
                helperText={formErrors.email}
                className="textField"
                fullWidth
                margin="normal"
              />

              <TextField
                label="Password"
                variant="outlined"
                name="password"
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={handleChange}
                error={Boolean(formErrors.password)}
                helperText={
                  formErrors.password ? (
                    <span
                      style={{
                        color:
                          formErrors.password ===
                          "Password must be at least 8 characters, include a number, a symbol, a lowercase and uppercase letter."
                            ? "#d32f2f"
                            : "#d32f2f",
                      }}
                    >
                      {formErrors.password}
                    </span>
                  ) : null
                }
                className="textField"
                onBlur={handleBlur}
                fullWidth
                margin="normal"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        <img src={showPassword ? '/assets/viewoff.svg' : '/assets/viewon.svg'} alt="Toggle Password Visibility" className="eye-icon" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Box className="passwordStrength" sx={{
                marginTop: formErrors.password === "Password must be at least 8 characters, include a number, a symbol, a lowercase and uppercase letter.." ?  "33px" : "5px",
              }}>
                {[...Array(5)].map((_, index) => (
                  <Box
                    key={index}
                    className={`passwordBar ${passwordStrength === "strong"
                      ? "strong"
                      : passwordStrength === "medium" && index <= 2
                        ? "medium"
                        : passwordStrength === "weak" && index <= 1
                          ? "weak"
                          : ""
                      }`}
                  />
                ))}
              </Box>
              <Box className="passwordMessage">
                {passwordStrength === "weak" && <p className="weak">Password is weak</p>}
                {passwordStrength === "medium" && <p className="medium">Password is fair</p>}
                {passwordStrength === "strong" && <p className="strong">Password is strong</p>}
              </Box>
              <TextField
                label="Confirm Password"
                variant="outlined"
                name="confirmPassword"
                type={showPassword ? "text" : "password"}
                value={formData.confirmPassword}
                onChange={handleChange}
                error={Boolean(formErrors.confirmPassword)}
                helperText={formErrors.confirmPassword}
                className="textField"
                fullWidth
                margin="normal"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {formData.password === formData.confirmPassword && formData.confirmPassword && (
                        <CheckIcon style={{ color: "#53E721" }} />
                      )}
                    </InputAdornment>
                  ),
                }}
              />

            <Box className="signin-button" sx={{mt: 2}}>
            <Button variant="contained"
            color="primary"
            fullWidth
            onClick={handleSubmit}
            className="submitButton"
          >
            Sign Up
          </Button>
            </Box>
            </div>
 <Box>
                          <div style={{ color: '#FFFFFF', fontSize: '16px', fontFamily: 'var(--font-family-primary)', textAlign:"center", marginTop:"10px" }}>
              By signing up, you agree to the{' '}
              <a
                href="/terms-of-service"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'underline', color: '#FFFFFF', fontFamily: 'var(--font-family-primary)', fontSize: '16px' }}
              >
                Terms of Services
              </a>{' '}
              and{' '}
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'underline', color: '#FFFFFF', fontFamily: 'var(--font-family-primary)', fontSize: '16px' }}
              >
                Privacy Policy
              </a>.
            </div>
                        <Typography variant="body2" align="center" className='login-short' sx={{ mt: 2 }}>
                            Already have an account? <span onClick={handleLogin} className='login-link'>Sign in</span>
                        </Typography>
                         <Box className="login-with">
                                                    <IconButton onClick={handleGoogleLogin} className='google-button'>
                                                        <img src='/assets/Google.svg' alt="Google Logo" className='google-logo'/>
                                                    </IconButton>
                                                </Box>

                    </Box>
          </Box>
        </Box>
      </Box>
    </>

  );
};

export default Signup;
